module.exports = __webpack_public_path__ + "3b86049c14945fb8a9792fb75777e8a3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GH.svg
// module id = Whe8
// module chunks = 0